<template>
  <div>
    <DeployContractCard />
  </div>
</template>
<script>
import DeployContractCard from '@/components/cards/DeployContractCard.vue';

export default {
  name: 'DeployContract',
  components: {
    DeployContractCard
  }
};
</script>
